
















import { Component, Vue } from "vue-property-decorator";
@Component
export default class Selector extends Vue {
  list = [100, 50, 10, 5, 1];

  itemClick(num: number) {
    this.$emit("set-num", num);
  }
}
